import PricingPPLWrapper from './PricingPPLWrapper'

export default PricingPPLWrapper
